import { useCallback, useEffect } from 'react';
import { getLocationAndWidth } from '../../../utils/mediaTimelineUtils';
import { getParsedPlayerStatuses } from '../../utils/getParsedPlayerStatuses';
export const useAnimateControls = ({
  mediaProgressBarRef,
  mediaRef,
  mediaState
}) => {
  // Provides a smooth animation for the player controls without causing a re-render
  const animatePlayerControls = useCallback(() => {
    if (mediaRef.current && mediaState.preciseDuration) {
      const currentTime = mediaRef.current.currentTime;
      const preciseDuration = mediaState.preciseDuration;

      // ProgressBar refers to the blue bar that fills up as the media plays
      if (mediaProgressBarRef.current) {
        mediaProgressBarRef.current.style.width = preciseDuration === 0 ? '0%' : `${getLocationAndWidth(currentTime, mediaState.clipEndTime, preciseDuration, false).width}%`;
      }
    }
  }, [mediaProgressBarRef, mediaRef, mediaState.clipEndTime, mediaState.preciseDuration]);
  const {
    isPlaying
  } = getParsedPlayerStatuses(mediaState.status);
  useEffect(() => {
    let playAnimation = null;
    if (isPlaying) {
      const animate = () => {
        animatePlayerControls();
        playAnimation = requestAnimationFrame(animate);
      };
      playAnimation = requestAnimationFrame(animate);
    }
    return () => {
      if (playAnimation !== null) {
        cancelAnimationFrame(playAnimation);
      }
    };
  }, [isPlaying, animatePlayerControls]);
  useEffect(() => {
    if (isPlaying) return;

    // solves for the case where the media is paused and the player head is updated
    animatePlayerControls();
  }, [mediaState.currentTime, animatePlayerControls, isPlaying]);
};